import { CancelToken } from "apisauce";
import React, { useState, useEffect } from "react";
import { createContext } from "react";

import { LocalStorage, SessionStorage } from "../utils";

export const StorageContext = createContext({});

export default function StorageProvider({ children }: any): JSX.Element {
  const [data, setData] = useState<any>({});
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [cancelToken, setCancelToken] = useState<any>(CancelToken.source());
  const [userData, setUserData] = useState<any>(null);
  useEffect(() => {
    const token = LocalStorage.getItem("token");
    const user = LocalStorage.getItem("userData");

    if (token && user) {
      setIsLogged(true);
    }
  }, [setIsLogged, setUserData]);

  function logOut() {
    removeData("token");
    LocalStorage.removeItem("token");
    LocalStorage.removeItem("userData"); 
    setUserData(null);
    setIsLogged(false);
  }

  function addData(key?: any, value?: any) {
    setData((state?: any) => ({ ...state, [key]: value }));
  }

  function removeData(key?: any) {
    setData((state?: any) => {
      const newState = state;
      delete newState[key];
      return newState;
    });
  }

  function getData(key?: any) {
    return data[key];
  }

  return (
    <StorageContext.Provider
      value={{
        addData,
        removeData,
        getData,
        isLogged,
        setIsLogged,
        logOut,
        userData,
        setUserData,
        cancelToken,
        setCancelToken,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
}
